/**
 * Helper module for geolocation with a cross-browser, modern interface.
 */

Promutuel.geolocation = {
  /**
   * Promisified `geolocation.getCurrentPosition()` wrapper.
   * Use this method with async/await syntax to make geolocation calls.
   */
  /*async*/ getCurrentPosition() {
    return new Promise((resolve, reject) => {
      if (!navigator.geolocation) reject(new Error('Geolocation is not supported.'));
      else navigator.geolocation.getCurrentPosition(resolve, reject);
    });
  },

  /**
   * Async geolocation permission helper.
   * Use this method with async/await syntax to check whether geolocation is allowed.
   *
   * @param {Object}  [options]
   *   See properties below.
   * @param {Boolean} [options.promptUser]
   *   When set to true, the user will be prompted if the permission can't be
   *   determined by other means,
   */
  async isGranted({promptUser = false} = {}) {
    if (!navigator.geolocation) return false;

    // If the browser supports the permissions API.
    if (navigator.permissions?.query) {
      const permission = await navigator.permissions.query({ name: 'geolocation' });
      if (permission.state == 'granted') return true;
      else if (permission.state == 'denied') return false;
    }

    // If the permission is still unknown, follow the `promptUser` parameter
    // to get a confirmation.
    if (promptUser) {
      try {
        await this.locateMeNow();
        return true;
      }
      catch (error) {
        return false;
      }
    }
    else {
      return false;
    }
  },
}
